import {NgModule} from '@angular/core';
import {FormSummaryValueConverter} from './api/entity/converter/formSummaryValue.converter';
import {FormFormSaveModule} from './api/component/form-form-save/form-form-save.component';
import {FormValueModule} from './value/formValue.module';
import {FormConverter} from './api/entity/converter/form.converter';
import {FormSummaryConverter} from './api/entity/converter/formSummary.converter';

@NgModule({
    imports: [
        FormValueModule,
        FormFormSaveModule,
    ],
})
export class FormFormModule {
}
